import React, { useState } from 'react';
import PreviewContent from './PreviewContent';
import { Props as PreviewContentProps } from './PreviewContent/PreviewContent';
import { choosePreviewContentType } from './choosePreviewContentType';
import { pickExtensionFromFilename } from './pickExtensionFromFilename';
import { pickDomainFromUrl } from './pickDomainFromUrl';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'file... Remove this comment to see the full error message
import filesize from 'filesize';

import type { LinkPreviewType } from '../types/LinkPreviewType';
import type { FilePreviewType } from '../types/FilePreviewType';

export interface Props {
  filePreview?: FilePreviewType;
  linkPreview?: LinkPreviewType;
  onDelete?: () => void;
  expand?: boolean;
  downloadable?: boolean;
  showTooltips?: boolean;
}

const Preview = ({
  filePreview,
  linkPreview,
  onDelete,
  expand,
  downloadable,
  showTooltips,
}: Props) => {
  const [hovered, setHovered] = useState(false);
  const [deleteHovered, setDeleteHovered] = useState(false);
  const hasError = filePreview ? filePreview.error : false;
  const loading = filePreview ? !filePreview.progress || filePreview.progress < 100 : false;
  let visual: PreviewContentProps['visual'] = 'normal';

  if (hasError) {
    visual = 'error';
    if (hovered) {
      visual = 'error-hovered';
    }
    if (deleteHovered) {
      visual = 'error-delete-hovered';
    }
  } else {
    if (loading) {
      visual = 'loading';
    } else {
      if (hovered) {
        visual = 'hovered';
      }
      if (deleteHovered) {
        visual = 'delete-hovered';
      }
    }
  }

  const sharedProps = {
    onMouseEnter: () => !hovered && setHovered(true),
    onMouseOut: () => hovered && setHovered(false),
    onMouseEnterDelete: () => !deleteHovered && setDeleteHovered(true),
    onMouseOutDelete: () => deleteHovered && setDeleteHovered(false),
    visual: visual,
    onDeleteClicked: onDelete,
  };

  if (!filePreview && !linkPreview) {
    console.error('please provide a file or a link');
    return null;
  }

  if (filePreview) {
    const previewContentType = choosePreviewContentType(
      filePreview.type,
      filePreview.thumbnail,
      filePreview.progress
    );
    let subtitle = '';
    if (filePreview.size) {
      subtitle = filesize(filePreview.size, { round: 1, spacer: '' }).toUpperCase();
    } else {
      const fileExtension = pickExtensionFromFilename(filePreview.fileName as string);
      subtitle = `${fileExtension} file`;
    }
    return (
      <PreviewContent
        {...sharedProps}
        previewContentType={previewContentType}
        title={filePreview.fileName}
        thumbnail={filePreview.thumbnail}
        subtitle={subtitle}
        expand={expand}
        downloadable={downloadable}
        showTooltips={showTooltips}
        url={filePreview.url}
        isFileSizeTooLarge={filePreview.isFileSizeTooLarge}
      />
    );
  }
  if (linkPreview && linkPreview.url) {
    const previewContentType = 'link';
    const domain = pickDomainFromUrl(linkPreview.url);
    return (
      <PreviewContent
        {...sharedProps}
        previewContentType={previewContentType}
        title={linkPreview.title}
        subtitle={linkPreview.description}
        thumbnail={linkPreview.image}
        domain={domain}
        url={linkPreview.url}
        expand={expand}
        downloadable={downloadable}
        showTooltips={showTooltips}
      />
    );
  }
  return null;
};

export default Preview;
